/**
 * Le fond animé ne sert à rien quand personne ne peut le voir, et il coûte cher
 * exactement quand le reste en a le plus besoin : sous un panneau qui recouvre
 * l'écran, et pendant qu'une carte vole.
 *
 * Le compte des raisons de le suspendre passe par ce module plutôt que par des
 * propriétés React : le fond est monté tout en haut de l'arbre, et le faire
 * dépendre d'un état de l'écran de jeu ferait re-rendre toute l'application à
 * chaque ouverture de panneau — l'inverse de ce qu'on cherche.
 */

let holds = 0;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

/** Suspend le fond ; la fonction rendue le relâche, une seule fois. */
export const holdBackdrop = (): (() => void) => {
  holds += 1;
  if (holds === 1) notify();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holds -= 1;
    if (holds === 0) notify();
  };
};

export const backdropSuspended = (): boolean => holds > 0;

export const onBackdropHoldChange = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
